import req from "../http";

const backgroundUser = {
  // 取得 後台使用者
  getBackgroundUser(params) {
    return req("get", "/auth/backgrounduser", params);
  },

  // 取得 後台使用者(分頁)
  getBackgroundUserPaging(params) {
    return req("get", "/auth/backgrounduser/paging", params);
  },

  // 新增 後台使用者
  postBackgroundUser(params) {
    return req("post", "/auth/backgrounduser", params);
  },

  // 更新 後台使用者 
  putBackgroundUser(params) {
    return req("put", "/auth/backgrounduser", params);
  },

  // 檢查是否需要變更密碼(與重設密碼相同則會回傳true)
  CheckNeedChangePasswordForEmp(params) {
    return req("get", "/auth/CheckNeedChangePasswordForEmp", params);
  },

  // 自行變更密碼
  ChangePasswordByOneself(params) {
    return req("post", "/auth/user/ChangePasswordByOneself", params);
  },
};

export default backgroundUser;
